/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgSessionUser } from './orgSessionUser';

export interface OrgSessionsResponse {
  users: OrgSessionUser[];
  total_sessions: number;
  total_users: number;
}
